import React, {Component} from 'react';
import ReactSVG from 'react-svg'
import moment from 'moment';
import timerIcon from '../../../assets/icons/timer.svg';

export default class DriverMarker extends Component {


    render() {

        if (!this.props.driver) {
            console.error("Creating a marker without driver")
            return null;
        }

        // console.log("Props: " + Object.keys(this.props.$geoService));


        const driver = this.props.driver;

        const driverNames = driver.name.split(' ');

        // Take the first letter of the driver's first name
        const firstLetter = driverNames[0][0].toUpperCase();

        // Take the first letter of the driver's last name
        const secondLetter = driverNames.length > 1 ?
            driverNames[driverNames.length - 1][0].toUpperCase() : '';

        const driverId = firstLetter + secondLetter;


        const isReturningDriverClose = driver.status === 'returning'
            && driver._returningInfo && driver._returningInfo.distance < 300;

        const isDriverHighlighted = this.props.highlightedDriver
            && this.props.highlightedDriver.id === driver.id;

        return (
            <div className={
                'map-driver ' + driver.status + ' ' +
                (isReturningDriverClose ? 'is-close ' : '') +
                (isDriverHighlighted ? 'highlight' : '')
            }>
                {driverId}
                {
                    driver.status === 'returning' && driver._returningInfo &&
                    <div className="map-driver-eta-wrapper">
                        <div className="map-driver-eta">
                            <ReactSVG path={timerIcon}/>
                            <span>
                                {moment(Date.now() - driver._returningInfo.duration).toNow(true)}
                            </span>
                        </div>
                    </div>
                }
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/app/Map/Elements/DriverMarker.js